"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _questionnaireActions = require("../../../store/questionnaire/questionnaireActions");
var _recommendationActions = require("../../../store/recommendation/recommendationActions");
var _EntelDynamicMessageTemplate = _interopRequireDefault(require("../../EntelDynamicMessageTemplate/EntelDynamicMessageTemplate"));
var _constants = require("../../../utils/constants");
var _upsellActions = require("../../../store/upsell/upsellActions");
var _uiSelectors = require("../../../store/ui/uiSelectors");
var _services = require("../../../services");
var _useAppDispatch = require("../../../hooks/useAppDispatch");
var _useAppSelector = require("../../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const WarningScreenBody = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const prevPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectPrevPage);
  const gotoPrevPage = () => {
    switch (prevPage) {
      case _constants.PAGES.RECOMMENDATION:
        dispatch((0, _upsellActions.goBackToRecommendation)());
        break;
      default:
        dispatch((0, _recommendationActions.goBackToCurrentQuestion)());
    }
  };
  return /*#__PURE__*/_react.default.createElement(_EntelDynamicMessageTemplate.default, {
    imagePath: "assets/ws10/icons/entel/Alert.png",
    translationKeys: {
      heading: 'WarningScreen.Heading',
      message: _services.Services.locale.localeString('WarningScreen.Message'),
      titleTestId: 'restart-title',
      subtitleTestId: 'restart-subtitle'
    },
    containerTestId: "warning-screen-body",
    buttons: {
      primary: {
        onClick: () => {
          dispatch((0, _questionnaireActions.resetQuestionnaire)());
          dispatch((0, _questionnaireActions.resetQuestionnaireOnConfirmMessage)());
        },
        translationKey: 'WarningScreen.ConfirmButton',
        buttonTestId: 'start-again-btn'
      },
      secondary: {
        onClick: () => gotoPrevPage(),
        translationKey: 'WarningScreen.CancelButton',
        buttonTestId: 'cancel-btn'
      }
    }
  });
};
var _default = WarningScreenBody;
exports.default = _default;